import jwtDecode from 'jwt-decode';

export const getTipoUsuario = () => {
  const token = getAcessToken();
  return token ? jwtDecode(token).tipoUsuario : null;
};

export const getEmpresaId = () => {
  const token = getAcessToken();
  return token ? jwtDecode(token).empresaId : null;
};

export const getAcessToken = () => {
  return localStorage.getItem('access_token') || sessionStorage.getItem('access_token') || null;
};

export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token') || sessionStorage.getItem('refresh_token') || null;
};

export const clearStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};
